<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpeakerOff_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M10.017 4.5a.83.83 0 0 0-.667.333L6.512 8.618l-2.737.547A2.084 2.084 0 0 0 2.1 11.208v1.584c0 .993.701 1.848 1.675 2.043l2.737.547 2.838 3.784a.833.833 0 0 0 1.5-.5V5.333a.833.833 0 0 0-.833-.833"
    />
</svg>
